import { render, staticRenderFns } from "./PhotographicProductionKpi.vue?vue&type=template&id=053f2ef6&scoped=true&"
import script from "./PhotographicProductionKpi.vue?vue&type=script&lang=js&"
export * from "./PhotographicProductionKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053f2ef6",
  null
  
)

export default component.exports